

const template = document.createElement('template');
const generateNavigationMarkup = (amtSteps:number) => {
  const steps = [...new Array(amtSteps)].map((step, index) => {
    return `<button page-index="${index}" class="navigation-button"><span>${index + 1}</span></button> ${index < amtSteps - 1 ? '<span class="navigation-separator"></span>' : ''}`;
  }).join('');

return `
<style>
  .personalisation-navigation {
    max-width: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1.25rem;
    margin-bottom: 2rem;
  }

  .navigation-button {
    height: 2.25rem;
    width: 2.25rem;
    min-width: 2.25rem;
    background-color: transparent;
    border-radius: 50%;
    border: 1px solid var(--transparent-navy-navy-12);
    color: var(--button-text);
    position: relative;
    transition: margin-right 0.5s, border-color 0.5s;
  }

  .navigation-button:last-child::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 0.9375rem;
    height: 0.625rem;
  }

  .navigation-button::after {
    content: '';
    width: 0;
    height: 0.0625rem;
    background-color: var(--transparent-navy-navy-12);
    position: absolute;
    top: calc(50% - 0.0625rem);
    left: calc(100% + 0.375rem); 
    transition: width 0.5s;
  }

  .navigation-button.is-active {
    border-color: var(--button-text);
    margin-right: auto;
  }

  .navigation-separator {
    background-color: var(--transparent-navy-navy-12);
    width: 100%;
    height: 0.0625rem;
  }

  .navigation-button:last-child.is-active {
    margin-left: 0;
    margin-right: 0;
  }

  .navigation-button:last-child.is-active::after {
    left: auto;
    right: calc(100% + 0.375rem);
  }

  @media screen and (max-width: 991px) {
    .personalisation-navigation {
      margin-top: 1.25rem;
      margin-bottom: 1.25rem;
    }
  }
</style>

<div class="personalisation-navigation" part="navigation">
  ${steps}
</div>
  `;
} 
export class PersonalisationNavigation extends HTMLElement {

  private readonly root:HTMLDivElement|null;
  private readonly stepTitles = JSON.parse(this.getAttribute('step-titles'));
  private readonly navBtns:NodeListOf<HTMLButtonElement>|[] = [];

  constructor() {
    super();
    const template = document.createElement('template');
    template.innerHTML = generateNavigationMarkup(this.stepTitles.length)

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));


    this.root = shadowRoot.querySelector('.personalisation-navigation')!;
    this.navBtns = this.root.querySelectorAll('.navigation-button');

    this.navBtns.forEach(btn => {
      btn.addEventListener('click', this.handleNavBtnClick);
    });
  }

  public setActive(pageIndex:number) {
    this.navBtns.forEach((btn, index) => {
      btn.classList[pageIndex === index ? 'add' : 'remove']('is-active');
    })
  }

  private handleNavBtnClick() {
    const btn = this;
    const pageIndex = parseInt(btn.getAttribute('page-index'));

    const event = new CustomEvent('navigation', {
      detail: { pageIndex }, 
      bubbles: true, 
      composed: true 
    });

    btn.dispatchEvent(event);
  }

}

if(!customElements.get('personalisation-navigation')) {
  customElements.define('personalisation-navigation', PersonalisationNavigation);
}